module.exports = __webpack_public_path__ + "img/jo3.9bc42f2c.png";